<template>
	<div class="setHeightFullGrey paddingbottom50">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
			
			
			<van-list v-model="loading" :finished="finished" finished-text="加载完毕" @load="onLoad">
				<div class="paddingbottom50">
					<div class="marginBottomXm" v-for="(item, index) in list"  :key="index">
						<div class="text-xl text-bold text-black paddingXm">{{ item.party_title }}</div>
						<div class="edits" @click="edits(item.party_id)">
							<van-cell title="营期" :value="item.set_title"  />
							<van-cell title="站点" :value="item.site"  />
							<van-cell title="应聘" :value="item.jobs"  />
						</div>
						  <template v-if="item.offer">
							  <van-cell title="录用" :value="item.offer"  />
							  <van-cell v-if="item.offer != '未录用'" title="操作"  >
								  <van-button slot="default"v-if="item.confirm_status == 0" type="primary" size="mini" @click="confirmThis(item.set_id)">确认</van-button>
								  <van-button slot="default"v-else-if="item.confirm_status == 1" size="mini" type="danger">已确认</van-button>
							  </van-cell>
						  	</template>
							<template v-else>
								 <van-cell title="状态" value="等待审核"  />
								 <van-cell title="操作" >
									<van-button slot="default" type="info" size="mini" @click="edits(item.party_id)">修改</van-button>						  
									</van-cell>
							</template>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
		
		
		<!-- 底部tab -->
		<myFoot></myFoot>
		<!-- 返回顶部 -->
		<backTop ref="bt"></backTop>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {
		computed: {
			...mapState(['site']),
		},
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				isLoading: false,
				page: 0,
				limits: 10,
				isFirstEnter:false
			};
		},
		watch: {
			"theSite": function(val) {

			}
		},
		beforeRouteEnter(to, from, next) {
			if (from.name == 'detail') {
				to.meta.isBack = true;
			};
			next();
		},
		activated() {
			if (!this.$route.meta.isBack || this.isFirstEnter) {
				 this.reload();
			} else {
			}
			this.$route.meta.isBack = false
			this.isFirstEnter = false;
		},
		created() {
			// this.loadData();
			this.wxShare();
		},
		methods: {
			confirmThis(id){
				const that=this;
				that.$dialog.confirm({
				  title: '提示',
				  message: '确认此岗位吗?'
				}).then((vars) => {
					let query={
						set_id:id
					};
				   try {
				   	that.$axios.post('apply/confirm',query).then(res => {
				   		let data = res.data.data;
				   		for (let i in that.list) {
							if(that.list[i].set_id==id){
								that.list[i].confirm_status=1;
							}
				   		};
				   	});
				   } catch (e) {
				   	if (this.$mConfig.debug) {
				   		console.log(e);
				   	};
				   }
				})
				
			},
			edits(id){
				this.$router.push({
					path: '/pages/detail/detail',
					query: {
						id: id
					}
				})
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast('刷新成功');
					this.isLoading = false;
					this.reload();
				}, 500);
			},
			onLoad() {
				// 异步更新数据
				setTimeout(() => {
					this.loadData();
				}, 500);
			},
			reload() {
				this.page = 0;
				this.list = [];
				this.loading = false;
				this.finished = false;
				this.onLoad();
			},
			go(name) {
				this.$router.push(`${name}`);
			},
			loadData() {
				const that = this;
				try {
					that.page++;
					that.$axios.get('apply?limit=' + that.limits + '&page=' + that.page).then(res => {
						let data = res.data.data;
						for (let i = 0; i < data.length; i++) {
							that.list.push(data[i]);
						}
						that.loading = false;
						if (data.length == 0) {
							that.finished = true;
						}
					});
				} catch (e) {
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
	}
</script>

<style scoped="scoped">
	@import url("../../colorui/main.css");
</style>
